<template lang="pug">
page.madden23(:show-header='false', :ga-event-category='gaEventCategory', :ga-event-label='gaEventLabel')
  //- Content
  template(slot='content')

    page-section.madden23-section.madden23-section--banner(:fullWidth='true', align='center')
      template(slot='content')
        .banner-img
          img(:src='this.getBannerSrc()')

    //- Main
    page-section#main.madden23-section.madden23-section--enter.page-pt-md-alt.page-pb-md(align='center')
      template(slot='content')
        //- Loading
        loading-icon.page-mt-lg-alt.page-mb-xxl(v-if='isLoading', size='lg', color='madden23-yellow')

        //- Ended View
        template(v-else-if='isEndedView')
          h1.h3 Thanks to everyone who entered!
          .fs-xs.page-mb-md-alt View winners

          //- Giveaway list
          giveaway-list.pt-2(
            :list='giveawayList',
            :show-prizes='false',
            :show-dates='false',
            :show-state='false',
            :show-action-button='true',
            action-button-variant='madden23-yellow',
            action-button-title='View Giveaway',
            action-button-margin-top='2',
            action-button-font-size='xs',
            title-size='xs',
            title-align='center',
            tile-size='lg',
            tile-size-sm='lg',
            tile-size-lg='lg',
            tile-classes='sm:page-px-md',
            :ga-event-category='gaEventCategory',
            :ga-event-label='gaEventLabel'
          )

        //- All other scenarios
        template(v-else)
          .text-center.mx-auto.max-w-md.page-mb-md
            h1.h2 Madden NFL 23 All Madden Edition Giveaway</span>
            .fs-sm.page-mb-md-alt Enter for PlayStation and Xbox below each day between 08/17 and 08/21

          //- Error
          template(v-if='isError') Sorry, there was an error, please try refreshing the page.

          //- No Giveaways
          template(v-else-if='!giveawayList.length') Coming Soon

          //- Has Giveaways
          template(v-else)

            //- Giveaway list
            giveaway-list.pt-2(
              :list='getShownGiveaways',
              :show-prizes='false',
              :show-dates='false',
              :show-state='false',
              :show-action-button='true',
              action-button-variant='madden23-yellow',
              action-button-title='Enter Giveaway',
              action-button-margin-top='2',
              action-button-font-size='xs',
              title-size='sm',
              title-align='center',
              tile-size='lg',
              tile-size-sm='lg',
              tile-size-lg='lg',
              tile-classes='sm:page-px-md',
              :ga-event-category='gaEventCategory',
              :ga-event-label='gaEventLabel'
            )

  //- Footer
  template(slot='footer')
    base-footer(:ga-event-category='gaEventCategory', :ga-event-label='gaEventLabel')
</template>
<script>
import GiveawayStartsIn from '../components/GiveawayStartsIn'
import GiveawayEndsIn from '../components/GiveawayEndsIn'
import BaseFooter from '../components/BaseFooter'
import multipleGiveawaysInSyncMixin from '../mixins/base/multiple-giveaways-in-sync'

export default {
  name: 'Madden23',
  mixins: [multipleGiveawaysInSyncMixin],
  data() {
    return {
      pageMetaTitle: 'Madden 23',
      idTokens: [
        'cqi_k9m',
        'D8isD7T',
        'PoDCiAC',
        'xQfKEZU',
        'hMrO0sB',
        'RYwnxtC',
        'xhPv-Hy',
        'axMe8T_',
        'sbFXbTt',
        'HH1bavv'
      ],
      day1Src: require('../assets/themes/madden23/images/MADDEN23-banner_day1.png'),
      day2Src: require('../assets/themes/madden23/images/MADDEN23-banner_day2.png'),
      day3Src: require('../assets/themes/madden23/images/MADDEN23-banner_day3.png'),
      day4Src: require('../assets/themes/madden23/images/MADDEN23-banner_day4.png'),
      day5Src: require('../assets/themes/madden23/images/MADDEN23-banner_day5.png')
    }
  },
  computed: {
    countdownTemplate() {
      return this.isUnderway ? GiveawayEndsIn : GiveawayStartsIn
    },
    getShownGiveaways() {
      var giveaways = this.giveawayList.filter((g) => {
        return g.isActive
      })

      if (giveaways.length > 0) {
        return giveaways.slice(0, 2)
      }

      return this.giveawayList.slice(0, 2)
    }
  },
  methods: {
    getBannerSrc() {
      const shownGiveaways = this.getShownGiveaways

      if (shownGiveaways.some((g) => g.record.idToken === 'RYwnxtC')) {
        return this.day1Src
      }

      if (shownGiveaways.some((g) => g.record.idToken === 'xhPv-Hy')) {
        return this.day2Src
      }

      if (shownGiveaways.some((g) => g.record.idToken === 'axMe8T_')) {
        return this.day3Src
      }

      if (shownGiveaways.some((g) => g.record.idToken === 'sbFXbTt')) {
        return this.day4Src
      }

      return this.day5Src
    },
    // Override from 'multipleGiveawaysInSyncMixin'
    sortGiveaways(giveawayList) {
      const sortedList = giveawayList.sort((a, b) => {
        return a.record.startTime > b.record.startTime ? 1 : -1
      })
      return sortedList
    }
  },
  components: {
    GiveawayStartsIn,
    GiveawayEndsIn,
    BaseFooter
  }
}
</script>
<style lang="scss" src="../assets/themes/madden23/scss/main.scss" />
